(() => {
  const summary = document.querySelector('[data-loxstar-review-summary]');
  if (!summary) return;
  const placeSummary = () => {
    const root = document.querySelector('#replo-fullpage-element');
    if (!root?.hasAttribute('data-alchemy-element-root')) return false;
    const product = root.querySelector(
      `[data-replo-product-container="${summary.dataset.productId}"]`
    );
    const rating = product?.querySelector(
      '[data-rid="ed7abcd7-d090-4fd9-987e-2c1ddb7bca9e"], ' +
      '[data-rid="8eadd975-f2ba-4c49-9cc6-8df31b8c07b5"]'
    );
    if (!rating) return false;
    rating.setAttribute('data-loxstar-review-link', '');
    rating.setAttribute('role', 'link');
    rating.setAttribute('tabindex', '0');
    rating.setAttribute('aria-label', summary.getAttribute('aria-label'));
    rating.setAttribute('data-loxstar-rating-label',
      summary.querySelector('.loxstar-review-score').textContent.trim() + ' · ' +
      summary.querySelector('.loxstar-review-count').textContent.trim()
    );
    rating.style.setProperty('--loxstar-star-fill', summary.querySelector('.loxstar-review-stars').style.getPropertyValue('--loxstar-star-fill'));
    const openReviews = () => {
      const section = document.getElementById('loxstar-customer-reviews');
      section.scrollIntoView({ block: 'start' });
      section.focus({ preventScroll: true });
    };
    rating.addEventListener('click', openReviews);
    rating.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        openReviews();
      }
    });
    summary.hidden = true;
    return true;
  };
  let attempts = 0;
  const whenReady = () => {
    if (placeSummary() || ++attempts >= 20) return;
    window.setTimeout(whenReady, 250);
  };
  const start = () => window.requestAnimationFrame(() => window.requestAnimationFrame(whenReady));
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
